<template>

    <div class="auth-wrapper auth-v2 px-1 d-flex flex-column">

        <div class="incomeTitle mt-3 ml-2">Tipo de Ingresos</div>
        <div class="flex-column w-100 align-items-center  flex-fill justify-content-center">
       
                <b-link :to="{ name: 'advance-economicsproduct' }" class="w-100 mb-5" style="color:white">
                    <b-button class="bg-primary"  block>Productos</b-button>
                </b-link>
       
                <b-link :to="{ name: 'advance-economicsanimal' }" class="w-100" style="color:white">
                    <b-button class="bg-primary" block>Animales</b-button>
                </b-link>
          
        </div>
        <ControlMenu />
    </div>
</template>


<script>
import ControlMenu from '@/components/ControlMenu.vue'
import { BButton, BLink } from 'bootstrap-vue'

export default {
    components: {
        ControlMenu,
        BLink,
        BButton
    },
}
</script>

<style lang="scss">
.incomeTitle {
    position:absolute;
    top:5%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;

}
@import '@core/scss/vue/pages/page-auth.scss';


</style>